import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ToggleGroupDynamicStyleType,
    ToggleGroupVariant
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getElevationStyle
} from "../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    getHugStyle
} from "../../helpers/theme/spread";

export const TOGGLE_GROUP_GAPS: Record<ToggleGroupVariant, keyof NCoreUIKit.Spaces> = {
    outline: "spacingSm",
    ghost: "spacingXxs"
};

const stylesheet = StyleSheet.create({
    vertical: {
        flexDirection: "column",
        alignItems: "stretch"
    },
    attached: {
        alignItems: "stretch",
        isolation: "isolate",
        gap: 0
    },
    stretch: {
        alignSelf: "stretch",
        width: "100%"
    },
    container: {
        alignItems: "center"
    },
    horizontal: {
        flexDirection: "row"
    }
});

export const useStyles = ({
    attachBehaviour,
    spreadBehaviour,
    shapeConfigs,
    outerRadius,
    shadowAlpha,
    elevations,
    userStyle,
    variant,
    colors,
    spaces
}: ToggleGroupDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(spreadBehaviour === "baseline") {
        Object.assign(styles.container, getHugStyle({
            style: userStyle
        }));
    }

    if(spreadBehaviour === "stretch") {
        Object.assign(styles.container, stylesheet.stretch);
    }

    if(attachBehaviour === "separate") {
        styles.container.gap = spaces[TOGGLE_GROUP_GAPS[variant]];
    }

    if(attachBehaviour === "attached") {
        Object.assign(styles.container, getCornerStyle({
            radius: outerRadius,
            shapeConfigs
        }));

        if(elevations.level1.length) {
            Object.assign(styles.container, getElevationStyle({
                shadowColor: colors.system.shadow,
                level: "level1",
                shadowAlpha,
                elevations
            }));
        }
    }

    return styles;
};
export default stylesheet;
